import { ExpertiseArticle } from '@components/expertiseArticle/ExpertiseArticle'
import { ExpertiseDetailHeader } from '@components/expertiseDetailHeader/ExpertiseDetailHeader'

export const ExpertisePage = () => {
    return (
        <>
            <ExpertiseDetailHeader />
            <ExpertiseArticle />
        </>
    )
}
